import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {EnvironmentService} from './environment.service';
import {Product} from '../models/product';
import {PaylinkSubscription} from '../models/paylink-subscription';
import {OrdersClient} from '../models/orders';
import {OrdersPacket} from '../models/order-packet.model';
import {Router} from '@angular/router';
import {MerchantPaylinkPaymentResponse} from '../models/merchant-paylink-payment-response';
import {SubAccount} from '../models/sub-account';
import {
  ApproveMerchantRelationshipRequest,
  ApproveMerchantRelationshipResponse,
  CancelMerchantRelationshipRequest,
  CancelMerchantRelationshipResponse,
  ConnectMerchantWithPartnerRequest,
  ConnectMerchantWithPartnerResponse,
  RejectMerchantRelationshipRequest,
  RejectMerchantRelationshipResponse,
  TerminateMerchantRelationshipRequest,
  TerminateMerchantRelationshipResponse
} from '../models/connect-merchant-with-partner-request';
import {Partner} from '../models/partner';
import {Withdraws} from '../models/withdraws';
import {PartnerMerchantRelationship} from '../models/partner-merchant-relationship.model';
import {InvoiceThemes} from '../models/invoice-themes';
import {MerchantService} from '../models/merchant-service.model';
import {NewSubAccountRequest} from '../models/new-sub-account-request';
import {MerchantWebhooks} from '../models/webhook';
import {UpdateAccountRequest} from '../models/update-account-requests';
import {UpdateAccountInitInfo} from '../models/update-account-init-info';
import {Collection} from '../models/collection';
import {WebsitePage} from '../models/website-page';
import * as pako from 'pako';
import {MyBusiness} from '../models/my-business';
import {firstValueFrom} from 'rxjs';
import {CouponCode} from '../models/coupon-code';

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // tslint:disable-next-line:one-variable-per-declaration no-bitwise
    const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

@Injectable({
  providedIn: 'root'
})
export class ApiAgentService {

  constructor(private http: HttpClient, private environmentService: EnvironmentService, public router: Router) {
  }

  private postPublic(endpoint: any, data: any) {
    let url = this.environmentService.getRest() + endpoint;
    return new Promise((resolve, reject) => {
      firstValueFrom(this.http.post(url, data)).then(response => {
        resolve(response);
      }).catch(e => {
        reject(e);
      });
    });
  }

  public getToken() {
    return localStorage.getItem('token');
  }

  private getSecuredWithoutContentType(endpoint: any, contentType: string): any {
    return new Promise(async (resolve, reject) => {
      let url = this.environmentService.getRest() + endpoint;
      let token = localStorage.getItem('token');
      const headers: HttpHeaders = new HttpHeaders()
        // .set('timeout', '10000')
        .set('Content-Type', contentType)
        .set('Authorization', 'Bearer ' + token);
      try {
        // debugger;
        let response = await firstValueFrom(this.http.get(url, {headers: headers, responseType: 'text'}));
        resolve(response);
      } catch (e) {
        // debugger;
        this.check401(e);
        reject(e);
      }
    });
  }

  private getSecured(endpoint: any): any {
    return new Promise((resolve, reject) => {
      let url = this.environmentService.getRest() + endpoint;
      let token = localStorage.getItem('token');
      const headers: HttpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json; charset=utf-8')
        .set('Authorization', 'Bearer ' + token);
      firstValueFrom(this.http.get(url, {headers: headers}))
        .then((response: any) => {
          resolve(response);
        }).catch((e: any) => {
        this.check401(e);
        reject(e);
      });
    });
  }

  private check401(e: any) {
    if (e.status == 401) {
      localStorage.removeItem('token');
      this.router.navigate(['auth/login']).then();
    }
  }

  private getSecuredWithResponseType(endpoint: any, responseType: any) {
    let url = this.environmentService.getRest() + endpoint;
    return new Promise((resolve, reject) => {
      let token = localStorage.getItem('token');
      const headers: HttpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + token);
      firstValueFrom(this.http.get(url, {headers: headers, responseType: responseType}))
        .then(response => {
          resolve(response);
        }).catch(e => {
        reject(e);
      });
    });
  }

  private postFileSecured(endpoint: any, file: File, captchaToken = null): Promise<any> {
    let url = this.environmentService.getRest() + endpoint;
    return new Promise((resolve, reject) => {
      let token = localStorage.getItem('token');
      let headers: HttpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + token);
      if (captchaToken) {
        headers = headers.set('captcha-token', captchaToken);
      }

      // Prepare the form data
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);

      // Note: Don't set the Content-Type header manually when using FormData
      // The browser will set it with the proper boundary
      firstValueFrom(this.http.post(url, formData, {headers: headers}))
        .then((response: any) => {
          resolve(response);
        }).catch((e: any) => {
        this.check401(e);
        reject(e);
      });
    });
  }


  private postSecured(endpoint: any, data: any, captchaToken = null): any {
    let url = this.environmentService.getRest() + endpoint;
    console.log('post secure line 140: url', url);
    return new Promise((resolve, reject) => {
      let token = localStorage.getItem('token');
      let headers: HttpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json; charset=utf-8')
        .set('Authorization', 'Bearer ' + token);
      if (captchaToken) {
        headers = new HttpHeaders()
          .set('Content-Type', 'application/json; charset=utf-8')
          .set('captcha-token', captchaToken)
          .set('Authorization', 'Bearer ' + token);
      }
      console.log('post secure line 152: headers', headers);
      console.log('post secure line 153: data', data);
      console.log('post secure line 154: url', url);
      firstValueFrom(this.http.post(url, data, {headers: headers}))
        .then(response => {
          console.log('post secure line 141: response', response);
          resolve(response);
        }).catch(e => {
        console.log('api error', e);
        this.check401(e);
        reject(e);
      });
    });
  }

  requestChangeMobileNumber(newMobileNumber: any) {
    let endpoint = '/rest/request-change-my-mobile';
    let data = {
      mobile: newMobileNumber
    };
    return this.postSecured(endpoint, data);
  }

  validateStoreUsername(storeUsername: string): any {
    let endpoint = '/rest/validateStoreUsername';
    let data = {
      storeUsername: storeUsername
    };
    return this.postSecured(endpoint, data);
  }

  confirmMobileNumber(newMobileNumber: any, otp: any) {
    let endpoint = '/rest/confirm-change-my-mobile';
    let data = {
      mobile: newMobileNumber,
      otp: otp
    };
    return this.postSecured(endpoint, data);
  }

  getTransferSettings() {
    let endpoint = '/rest/my-transfer-settings';
    return this.getSecured(endpoint);
  }

  getBankNames() {
    let endPoint = '/openApi/bank-names';
    return this.getSecured(endPoint);
  }

  getMyBusiness(fetch: boolean): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let endpoint = '/rest/getMyBusiness';
      let myBusinessJson = sessionStorage.getItem('myBusiness');
      let myBusiness: MyBusiness;
      if (myBusinessJson != null && fetch == false) {
        myBusiness = JSON.parse(myBusinessJson);
        console.log('my business uses cache');
      } else {
        myBusiness = await this.getSecured(endpoint);
        if (myBusiness != null) {
          console.log('my business used data from server');
          myBusinessJson = JSON.stringify(myBusiness);
          sessionStorage.setItem('myBusiness', myBusinessJson);
        } else {
          reject({error: 'could not get my business'});
        }
      }
      resolve(myBusiness);
    });
  }

  getMyServices(): Promise<MerchantService[]> {
    let endpoint = '/rest/getMyServices';
    return this.getSecured(endpoint);
  }

  getMyLightBusiness(): Promise<any> {
    let endpoint = '/rest/getMyLightBusiness';
    return this.getSecured(endpoint);
  }

  getCheckPartnerConnections(): Promise<PartnerMerchantRelationship[]> {
    let endpoint = '/rest/partner/connections/check-list';
    return this.getSecured(endpoint);
  }

  getMyPartners(): Promise<Partner[]> {
    let endpoint = '/rest/partner/getMyPartners';
    return this.getSecured(endpoint);
  }

  getAccountUpdates(): Promise<UpdateAccountRequest[]> {
    const endpoint = '/rest/accountUpdates/myRequests';
    return this.getSecured(endpoint);
  }

  getMyPartnerMerchants(): Promise<PartnerMerchantRelationship[]> {
    let endpoint = '/rest/partner/getMyMerchants';
    return this.getSecured(endpoint);
  }

  getMerchantRelationship(profileNo: any): Promise<PartnerMerchantRelationship> {
    let endpoint = '/rest/partner/relationship/merchant/' + profileNo;
    return this.getSecured(endpoint);
  }

  getMyPartnerSettlements(): Promise<Withdraws[]> {
    let endpoint = '/rest/partner/getMySettlements';
    return this.getSecured(endpoint);
  }

  getMyPartnerIncomes(): Promise<OrdersClient[]> {
    let endpoint = '/rest/partner/getMyIncomes';
    return this.getSecured(endpoint);
  }

  getMyApiSettings() {
    let endpoint = '/rest/getApiSettings';
    return this.getSecured(endpoint);
  }

  getUpdateAccountInitInfo(): Promise<UpdateAccountInitInfo> {
    let endpoint = '/rest/accountUpdates/initInfo';
    return this.getSecured(endpoint);
  }

  cancelAccountUpdate(id: any) {
    const endpoint = '/rest/accountUpdates/cancel';
    let data = {
      accountId: id
    };
    return this.postSecured(endpoint, data);
  }

  saveAccountUpdate(payload: any) {
    const endpoint = '/rest/accountUpdates/save';
    return this.postSecured(endpoint, payload);
  }

  uploadFileToServer(fileBytes: any) {
    const endpoint = '/rest/upload-fr-license';
    return this.postFileSecured(endpoint, fileBytes);
  }

  saveAccountUpdateOtp(payload: any) {
    const endpoint = '/rest/accountUpdates/otp';
    return this.postSecured(endpoint, payload);
  }

  checkAccountUpdateOtp(payload: any) {
    const endpoint = '/rest/accountUpdates/activate';
    return this.postSecured(endpoint, payload);
  }

  validateCouponCode(couponCode: any): PaylinkSubscription[] {
    let endpoint = '/rest/validate-coupon';
    let data = {
      couponCode: couponCode
    };
    return this.postSecured(endpoint, data);
  }

  getPaylinkSubscriptions(): Promise<PaylinkSubscription[]> {
    let endpoint = '/rest/paylink-subscriptions';
    return this.getSecured(endpoint);
  }

  processMerchantPackagePayment(transactionNo: any, orderNumber: any): Promise<any> {
    let endpoint = '/rest/processMerchantPackagePayment';
    let data = {
      paymentRequestNo: orderNumber,
      orderNumber: transactionNo
    };
    return this.postSecured(endpoint, data);
  }

  processSubAccountPaymentRequest(transactionNo: any, orderNumber: any): Promise<any> {
    let endpoint = '/rest/process-sub-account-payment-request';
    let data = {
      paymentRequestNo: orderNumber,
      orderNumber: transactionNo
    };
    return this.postSecured(endpoint, data);
  }

  getMyBusinessDashboard() {
    let endpoint = '/rest/getMyBusinessDashboard';
    return this.getSecured(endpoint);
  }

  getMyAdsNote() {
    let endpoint = '/rest/getMyAdsNote';
    return this.getSecured(endpoint);
  }

  getMyBusinessDashboardTopTenClients() {
    let endpoint = '/rest/getMyBusinessDashboardTopTenClients';
    return this.getSecured(endpoint);
  }

  getMyBusinessDashboardTopTenProducts() {
    let endpoint = '/rest/getMyBusinessDashboardTopTenProducts';
    return this.getSecured(endpoint);
  }

  postDeleteProduct(productId: any) {
    let endpoint = '/rest/deleteProduct';
    let data = {id: productId};
    return this.postSecured(endpoint, data);
  }

  loadCollections(): Promise<Collection[]> {
    let endpoint = '/rest/collections';
    return this.getSecured(endpoint);
  }

  loadCollection(id: any): Promise<Collection> {
    let endpoint = '/rest/collections/' + id;
    return this.getSecured(endpoint);
  }

  postCollection(payload: Collection) {
    let endpoint = '/rest/collections/save';
    return this.postSecured(endpoint, payload);
  }

  postDeleteCollection(collectionId: any) {
    let endpoint = '/rest/collections/delete';
    let data = {id: collectionId};
    return this.postSecured(endpoint, data);
  }

  loadWebsitePages(): Promise<WebsitePage[]> {
    let endpoint = '/rest/websitePages';
    return this.getSecured(endpoint);
  }

  loadWebsitePage(id: any): Promise<WebsitePage> {
    let endpoint = '/rest/websitePages/' + id;
    return this.getSecured(endpoint);
  }

  postWebsitePage(payload: WebsitePage) {
    let endpoint = '/rest/websitePages/save';
    return this.postSecured(endpoint, payload);
  }

  postDeleteWebsitePage(websitePageId: any) {
    let endpoint = '/rest/websitePages/delete';
    let data = {id: websitePageId};
    return this.postSecured(endpoint, data);
  }


  postProductLink(productId: any, productLink: any) {
    let endpoint = '/rest/postProductLink';
    let data = {id: productId, linkIdentity: productLink};
    return this.postSecured(endpoint, data);
  }

  changePassword(mobile: any, otp: any, newPassword: any, isSubAccount: boolean): any {
    let endpoint = '/openApi/reset-password/finish';
    let data = {key: otp, newPassword: newPassword, mobile: mobile, isSubAccount: isSubAccount};
    return this.postPublic(endpoint, data);
  }

  async postProduct(title: any, price: any, image: any, thumbnail: any, gridImage: any, description: any, qty: any, digital: any, coupons: CouponCode[]) {
    let endpoint = '/rest/postProduct';
    let data = {
      title: title,
      persist: true,
      price: price,
      stockQty: qty,
      description: description,
      isDigital: digital,
      discountCoupons: coupons ? JSON.stringify(coupons) : coupons
    };
    let p = await this.postSecured(endpoint, data);
    let id = p.id;

    if (image) {
      console.log('uploading product image');
      await this.uploadChunks(id, image, 'productImage');
    }
    if (thumbnail) {
      console.log('uploading thumbnail image');
      await this.uploadChunks(id, thumbnail, 'thumbnailImage');
    }
    if (gridImage) {
      console.log('uploading grid image');
      await this.uploadChunks(id, gridImage, 'gridImage');
    }
  }

  public compressBase64(base64: string): string {
    const binaryString = atob(base64.split(',')[1]);
    const charCodes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      charCodes[i] = binaryString.charCodeAt(i);
    }
    const compressedData = pako.deflate(charCodes);
    return this.uint8ArrayToBase64(compressedData);
  }

  private uint8ArrayToBase64(uint8Array: Uint8Array): string {
    let binary = '';
    const len = uint8Array.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(uint8Array[i]);
    }
    return btoa(binary);
  }

  getOrder(orderNumber: any): Promise<OrdersPacket> {
    let endpoint = '/rest/getMyOrder/' + orderNumber;
    return this.getSecured(endpoint);
  }

  getOrders() {
    let endpoint = '/rest/getMyOrders';
    return this.getSecured(endpoint);
  }

  getOrdersByStatus(status: any) {
    let endpoint = '/rest/getMyDesktopOrdersByStatus/' + status;
    return this.getSecured(endpoint);
  }

  getOrdersPageByStatus(status: any, page: any) {
    let endpoint = '/rest/getMyDesktopOrdersByStatus/' + status + '?page=' + page;
    return this.getSecured(endpoint);
  }

  getOrdersPageByStatusAndFilter(status: any, page: any, filter: any) {
    console.log('filter', filter);
    console.log('status', status);
    console.log('page', page);
    let endpoint = '/rest/getMyDesktopOrdersByStatus/' + status + '?page=' + page + '&filter=' + filter;
    return this.getSecured(endpoint);
  }

  getClients() {
    let endpoint = '/rest/getMyClients';
    return this.getSecured(endpoint);
  }

  getSubAccounts() {
    let endpoint = '/rest/getMySubAccounts';
    return this.getSecured(endpoint);
  }

  addSubAccount(name: any, mobile: any, govId: any, requestNo: any): Promise<any> {
    let endpoint = '/rest/post-adding-sub-account';
    let data = {
      mainMerchantId: -1,
      mobile: mobile,
      govId: govId,
      fullName: name,
      requestNo: requestNo
    };
    return this.postSecured(endpoint, data);
  }

  addSubAccountOtp(subId: any, name: any, mobile: any, govId: any, requestNo: any, otp: any): Promise<any> {
    let endpoint = '/rest/post-adding-sub-account-otp';
    let data = {
      mainMerchantId: -1,
      id: subId,
      mobile: mobile,
      govId: govId,
      fullName: name,
      otpCode: otp,
      requestNo: requestNo
    };
    return this.postSecured(endpoint, data);
  }

  getSubAccountRequest(requestNo: any): Promise<any> {
    let endpoint = '/rest/get-sub-accounts-request-details/' + requestNo;
    return this.getSecured(endpoint);
  }

  getSubAccountsOfRequest(requestNo: any): Promise<SubAccount[]> {
    let endpoint = '/rest/get-sub-accounts-of-request/' + requestNo;
    return this.getSecured(endpoint);
  }

  getSubAccountRequests(): Promise<NewSubAccountRequest[]> {
    let endpoint = '/rest/get-sub-accounts-requests';
    return this.getSecured(endpoint);
  }

  cancelSubAccountRequest(requestId: any, merchantId: any): Promise<any> {
    let endpoint = '/rest/cancel-sub-account-request';
    let data = {
      id: requestId,
      merchantId: merchantId,
      count: 0,
      justification: ' '
    };
    return this.postSecured(endpoint, data);
  }

  async putProduct(id: any, title: any, price: any, image: any, thumbnailImage: any, gridImage: any, description: any, qty: any, digital: any, coupons: CouponCode[]) {
    let endpoint = '/rest/putProduct';
    let data = {
      id: id,
      title: title,
      price: price,
      stockQty: qty,
      isDigital: digital,
      description: description,
      discountCoupons: coupons ? JSON.stringify(coupons) : coupons
    };
    await this.postSecured(endpoint, data);

    // Replace direct image upload with chunked uploads
    if (image) {
      console.log('uploading product image');
      await this.uploadChunks(id, image, 'productImage');
    }
    if (thumbnailImage) {
      console.log('uploading thumbnail image');
      await this.uploadChunks(id, thumbnailImage, 'thumbnailImage');
    }
    if (gridImage) {
      console.log('uploading grid image');
      await this.uploadChunks(id, gridImage, 'gridImage');
    }
  }

  async uploadChunks(productId: number, image: string, imageType: string): Promise<void> {
    const endpoint = `/rest/putProductImageChunk`;
    const chunkSize = 512 * 1024; // 512 KB

    // Remove prefix and decode Base64 to Uint8Array
    const base64Data = image.split(',')[1]; // Remove the 'data:image/webp;base64,' prefix
    const byteStream = new Uint8Array(atob(base64Data).split('').map((c) => c.charCodeAt(0))); // Convert Base64 to bytes
    const totalChunks = Math.ceil(byteStream.length / chunkSize);

    console.log(`Uploading ${totalChunks} chunks for ${imageType}`);
    console.log(`Total bytes: ${byteStream.length}`);
    console.log(`Chunk size: ${chunkSize}`);
    console.log(`Total chunks: ${totalChunks}`);

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      console.log(`Uploading chunk ${chunkIndex + 1}/${totalChunks} for ${imageType}`);
      const start = chunkIndex * chunkSize;
      const end = Math.min(start + chunkSize, byteStream.length);
      const chunk = byteStream.slice(start, end);

      const payload = {
        productId,
        chunk: Array.from(chunk), // Convert Uint8Array to array for JSON serialization
        chunkIndex,
        totalChunks,
        imageType, // e.g., "productImage", "thumbnailImage", "gridImage"
      };

      let retries = 3;
      while (retries > 0) {
        try {
          // await this.http.post(endpoint, payload, {headers: {'Content-Type': 'application/json'}}).toPromise();
          await this.postSecured(endpoint, payload);
          console.log(`Chunk ${chunkIndex + 1}/${totalChunks} uploaded successfully for ${imageType}`);
          break;
        } catch (err) {
          retries--;
          if (retries === 0) {
            throw new Error(`Failed to upload chunk ${chunkIndex + 1} for ${imageType} after retries.`);
          }
          console.error(`Retrying chunk ${chunkIndex + 1} for ${imageType} (${3 - retries} retries left)`);
        }
      }
    }
  }

  // async putProductImage(id: any, image: string, thumbnailImage: string, gridImage: string) {
  //   let endpoint = '/rest/putProductImage';
  //   let data = {
  //     id: id,
  //     productImage: image != null ? this.compressBase64(image) : null,
  //     thumbnailImage: thumbnailImage != null ? this.compressBase64(thumbnailImage) : null,
  //     gridImage: gridImage != null ? this.compressBase64(gridImage) : null
  //   };
  //   await this.postSecured(endpoint, data);
  // }


  login(username: any, password: any, otp: any, mainMerchantId: any, isSubAccount: any): Promise<any> {
    let endpoint = isSubAccount ? '/api/authenticateSub' : '/api/authenticate';
    let data = {'username': username, 'password': password, 'rememberMe': 'true', 'otp': otp, 'mainMerchantId': mainMerchantId};
    return this.postPublic(endpoint, data);
  }

  getOtp(username: any): Promise<any> {
    let endpoint = '/api/otp';
    let data = {'username': username};
    return this.postPublic(endpoint, data);
  }

  getSubOtp(username: any): Promise<any> {
    let endpoint = '/api/sotp';
    let data = {'username': username};
    return this.postPublic(endpoint, data);
  }

  async loadProductImage(id: any): Promise<any> {
    let endpoint = '/rest/downloadProductImageBase64/' + id;
    return this.getSecuredWithResponseType(endpoint, 'image');
  }

  async loadProductThumbnailImage(id: string): Promise<any> {
    let endpoint = '/rest/downloadProductThumbnailImageBase64/' + id;
    return this.getSecuredWithResponseType(endpoint, 'image');
  }

  async loadProductGridImage(id: string): Promise<any> {
    let endpoint = '/rest/downloadProductGridImageBase64/' + id;
    return this.getSecuredWithResponseType(endpoint, 'image');
  }

  loadProducts(): Promise<Product[]> {
    let endpoint = '/rest/getProductsOfMerchant';
    return this.getSecured(endpoint);
  }

  loadProduct(id: any) {
    let endpoint = '/rest/getProductOfMerchant/' + id;
    return this.getSecured(endpoint);
  }

  resetPassword(mobile: any, isSubAccount: any) {
    let endpoint = '/openApi/reset-password/init';
    let data = {mobile: mobile.trim(), isSubAccount: isSubAccount};
    return this.postPublic(endpoint, data);
  }

  buildProduct(productId: any, title: any, price: any, soldPrice: any, qty: any): any {
    return {
      id: productId,
      title: title,
      price: price,
      soldPrice: soldPrice,
      qty: qty
    };
  }

  postWithdrawRequest(amount: any, iban: any, receiverName: any, bankName: any) {
    let endPoint = '/rest/withdrawal-request';
    let data = {
      amount: amount,
      ibanNumber: iban,
      bankName: bankName,
      receiverName: receiverName
    };
    return this.postSecured(endPoint, data);
  }

  getMyWalletTransactions(): any {
    let endpoint = '/rest/getMyWalletTransactions';
    return this.getSecured(endpoint);
  }

  getMyWalletSales(orderBy: any, index: any, offset: any): any {
    let endpoint = '/rest/getMyWalletSales?orderBy=' + orderBy + '&index=' + index + '&offset=' + offset;
    return this.getSecured(endpoint);
  }

  getMyWalletSalesUrl(): any {
    return this.environmentService.getRest() + '/rest/getMyWalletSales';
  }

  getSecuredHttpHeaders() {
    return {'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + this.getToken()};
  }

  getMyDailySales(): any {
    let endpoint = '/rest/get-daily-sales';
    return this.getSecured(endpoint);
  }

  addOrder(clientName: any, products: any, discount: any, vat: any, note: any, discountType: any, currency: string, token: any): Promise<any> {
    let endpoint = '/rest/postDesktopOrder';
    let data = {
      clientName: clientName,
      products: products,
      currency: currency,
      discount: discount,
      discountType: discountType == 'SAR' ? 'FIXED' : (discountType == '%' ? 'PERCENTAGE' : null),
      vat: vat,
      note: note
    };
    return this.postSecured(endpoint, data, token);
  }

  postOrderFile(orderNumber: any, fileBody: File) {
    let endpoint = '/rest/postDesktopOrderFile/' + orderNumber;
    return this.postFileSecured(endpoint, fileBody);
  }

  postSendSmsToOrderClient(orderNumber: any, smsPhoneNumber: any, countryCode: any) {
    let endpoint = '/rest/sendingSmsToOrderClient';

    let data = {
      orderNumber: orderNumber,
      phoneNumber: smsPhoneNumber,
      phoneNumberCountryCode: countryCode
    };

    return this.postSecured(endpoint, data);
  }

  cancelOrder(orderNumber: any) {
    let endpoint = '/rest/postOrderStatusAsCancelled';
    let data = {orderNumber: orderNumber};
    return this.postSecured(endpoint, data);
  }

  markOrderCompleted(orderNumber: any) {
    let endpoint = '/rest/postOrderStatusAsCompleted';
    let data = {orderNumber: orderNumber};
    return this.postSecured(endpoint, data);
  }

  refundOrder(orderNumber: any, refundReason: any) {
    let endpoint = '/rest/refund-order';
    let data = {orderNumber: orderNumber, refundReason: refundReason};
    return this.postSecured(endpoint, data);
  }

  cancelRefundOrder(orderNumber: any) {
    let endpoint = '/rest/cancel-refund-order';
    let data = {orderNumber: orderNumber};
    return this.postSecured(endpoint, data);
  }

  postMyBusinessData(businessName: any, firstName: any, lastName: any, vat: any, logoUrl: any, storeUsername: any) {
    let endpoint = '/rest/postMyBusiness';
    let data = {
      businessName: businessName,
      firstName: firstName,
      lastName: lastName,
      logoUrl: logoUrl,
      vat: vat,
      storeUsername: storeUsername
    };
    return this.postSecured(endpoint, data);
  }

  getSettlementWebhookData(): Promise<MerchantWebhooks> {
    return this.getSecured('/rest/getSettlementWebhook');
  }

  postSettlementWebhookData(webhookUrl: any, header1: any, header2: any, header3: any, header4: any, header5: any, value1: any, value2: any, value3: any, value4: any, value5: any, version: any) {
    let endpoint = '/rest/postSettlementWebhook';
    let data = {
      webhookUrl: webhookUrl,
      httpHeader1: header1,
      httpHeader2: header2,
      httpHeader3: header3,
      httpHeader4: header4,
      httpHeader5: header5,
      httpHeader1Value: value1,
      httpHeader2Value: value2,
      httpHeader3Value: value3,
      httpHeader4Value: value4,
      httpHeader5Value: value5,
      version: version
    };
    return this.postSecured(endpoint, data);
  }

  testSettlementWebhook(webhookUrl: any, header1: any, header2: any, header3: any, header4: any, header5: any, value1: any, value2: any, value3: any, value4: any, value5: any, version: any) {
    let data = {
      webhookUrl: webhookUrl,
      httpHeader1: header1,
      httpHeader2: header2,
      httpHeader3: header3,
      httpHeader4: header4,
      httpHeader5: header5,
      httpHeader1Value: value1,
      httpHeader2Value: value2,
      httpHeader3Value: value3,
      httpHeader4Value: value4,
      httpHeader5Value: value5,
      version: version
    };
    return this.postSecured('/rest/getSettlementWebhook', data);
  }

  getPaymentWebhookData(): Promise<MerchantWebhooks> {
    return this.getSecured('/rest/getPaymentWebhook');
  }

  postPaymentWebhookData(webhookUrl: any, header1: any, header2: any, header3: any, header4: any, header5: any, value1: any, value2: any, value3: any, value4: any, value5: any, version: any) {
    let endpoint = '/rest/postPaymentWebhook';
    let data = {
      webhookUrl: webhookUrl,
      httpHeader1: header1,
      httpHeader2: header2,
      httpHeader3: header3,
      httpHeader4: header4,
      httpHeader5: header5,
      httpHeader1Value: value1,
      httpHeader2Value: value2,
      httpHeader3Value: value3,
      httpHeader4Value: value4,
      httpHeader5Value: value5,
      version: version
    };
    return this.postSecured(endpoint, data);
  }

  testPaymentWebhook(webhookUrl: any, header1: any, header2: any, header3: any, header4: any, header5: any, value1: any, value2: any, value3: any, value4: any, value5: any, version: any) {
    let data = {
      webhookUrl: webhookUrl,
      httpHeader1: header1,
      httpHeader2: header2,
      httpHeader3: header3,
      httpHeader4: header4,
      httpHeader5: header5,
      httpHeader1Value: value1,
      httpHeader2Value: value2,
      httpHeader3Value: value3,
      httpHeader4Value: value4,
      httpHeader5Value: value5,
      version: version
    };
    console.log('testPaymentWebhook', data);
    return this.postSecured('/rest/testPaymentWebhook', data);
  }

  getPartnerActivationWebhookData(): Promise<MerchantWebhooks> {
    return this.getSecured('/rest/getPartnerActivationWebhook');
  }

  postPartnerActivationWebhookData(webhookUrl: any, header1: any, header2: any, header3: any, header4: any, header5: any, value1: any, value2: any, value3: any, value4: any, value5: any, version: any) {
    let endpoint = '/rest/postPartnerActivationWebhook';
    let data = {
      webhookUrl: webhookUrl,
      httpHeader1: header1,
      httpHeader2: header2,
      httpHeader3: header3,
      httpHeader4: header4,
      httpHeader5: header5,
      httpHeader1Value: value1,
      httpHeader2Value: value2,
      httpHeader3Value: value3,
      httpHeader4Value: value4,
      httpHeader5Value: value5,
      version: version
    };
    return this.postSecured(endpoint, data);
  }

  testPartnerActivationWebhook(webhookUrl: any, header1: any, header2: any, header3: any, header4: any, header5: any, value1: any, value2: any, value3: any, value4: any, value5: any, version: any) {
    let data = {
      webhookUrl: webhookUrl,
      httpHeader1: header1,
      httpHeader2: header2,
      httpHeader3: header3,
      httpHeader4: header4,
      httpHeader5: header5,
      httpHeader1Value: value1,
      httpHeader2Value: value2,
      httpHeader3Value: value3,
      httpHeader4Value: value4,
      httpHeader5Value: value5,
      version: version
    };
    return this.postSecured('/rest/testPartnerActivationWebhook', data);
  }

  postMerchantPackageRenew(paylinkSubscriptionId: any, paymentPlan: any, paymentVia: any, amount: any): Promise<any> {
    let endpoint = '/rest/renewMerchantPackage';
    let data = {
      paylinkSubscriptionId: paylinkSubscriptionId,
      paymentPlan: paymentPlan,
      paymentVia: paymentVia,
      amount: amount,
      status: 'renew'
    };
    return this.postSecured(endpoint, data);
  }

  postSubAccountPaymentRequest(requestNo: any, paymentVia: any): Promise<MerchantPaylinkPaymentResponse> {
    let endpoint = '/rest/post-sub-account-payment-request';
    let data = {
      requestNo: requestNo,
      paymentVia: paymentVia
    };
    return this.postSecured(endpoint, data);
  }

  postMerchantPackageChange(paylinkSubscriptionId: any, paymentPlan: any, paymentVia: any, amount: any, coupon: any): Promise<any> {
    let endpoint = '/rest/changeMerchantPackage';
    let data = {
      paylinkSubscriptionId: paylinkSubscriptionId,
      paymentPlan: paymentPlan,
      paymentVia: paymentVia,
      amount: amount,
      coupon: coupon
    };
    return this.postSecured(endpoint, data);
  }

  postMyBusinessImage(imageBase64: any): any {
    if (imageBase64 && imageBase64.indexOf('data:') > -1) {
      imageBase64 = imageBase64.substring(imageBase64.indexOf(',') + 1);
    }

    let imageId = uuidv4();
    let endpoint = '/rest/postMyBusinessImageJson';
    let data = {
      imageId: imageId,
      imageBase64: imageBase64
    };
    return this.postSecured(endpoint, data);
  }

  getMyBusinessImage(): any {
    let endpoint = '/rest/getMyBusinessImage/150/150';
    return this.getSecuredWithResponseType(endpoint, 'blob');
  }

  async requestSubAccountsCount(subAccountsCount: number, justification: string) {
    let endpoint = '/rest/request-sub-accounts-count';
    let data = {
      count: subAccountsCount,
      justification: justification
    };
    return this.postSecured(endpoint, data);
  }

  async requestSubAccountsCountAbsher(otp: string, approvalRequestNo: number) {
    let endpoint = '/rest/request-sub-accounts-count-otp';
    let data = {
      otp: otp,
      approvalRequestNo: approvalRequestNo
    };
    return this.postSecured(endpoint, data);
  }

  connectWithMerchant(connectRequest: ConnectMerchantWithPartnerRequest): Promise<ConnectMerchantWithPartnerResponse> {
    let endpoint = '/rest/partner/connect-merchant';
    return this.postSecured(endpoint, connectRequest);
  }

  cancelMerchantRelationship(cancelRequest: CancelMerchantRelationshipRequest): Promise<CancelMerchantRelationshipResponse> {
    let endpoint = '/rest/partner/cancel-merchant';
    return this.postSecured(endpoint, cancelRequest);
  }

  approveMerchantRelationship(approveRequest: ApproveMerchantRelationshipRequest): Promise<ApproveMerchantRelationshipResponse> {
    let endpoint = '/rest/partner/approve-merchant';
    return this.postSecured(endpoint, approveRequest);
  }

  confirmMerchantRelationship(confirmRequest: ApproveMerchantRelationshipRequest): Promise<ApproveMerchantRelationshipResponse> {
    let endpoint = '/rest/partner/confirm-merchant';
    return this.postSecured(endpoint, confirmRequest);
  }

  terminateMerchantRelationship(terminateRequest: TerminateMerchantRelationshipRequest): Promise<TerminateMerchantRelationshipResponse> {
    let endpoint = '/rest/partner/terminate-merchant';
    return this.postSecured(endpoint, terminateRequest);
  }

  rejectMerchantRelationship(rejectRequest: RejectMerchantRelationshipRequest): Promise<RejectMerchantRelationshipResponse> {
    let endpoint = '/rest/partner/reject-merchant';
    return this.postSecured(endpoint, rejectRequest);
  }

  downloadShopifyMatchingOrders(fileName: string, formData: FormData) {
    let endpoint = '/rest/downloadShopifyMatchingOrders';
    return this.postSecured(endpoint, {fileBody: formData, fileName: fileName});
  }

  async getDemoInvoiceUrl() {
    let endpoint = '/rest/createDemoInvoice';
    return this.getSecured(endpoint);
  }

  async getMyInvoiceThemes() {
    let endpoint = '/rest/getMyInvoiceThemes';
    return this.getSecured(endpoint);
  }

  async getDefaultInvoiceThemes() {
    let endpoint = '/rest/getDefaultInvoiceThemes';
    return this.getSecured(endpoint);
  }

  async postPdfVatReport(year: any, month: any, vatCertId: any) {
    let endpoint = '/rest/postPdfVatReport';
    return this.postSecured(endpoint, {year: year, month: month, vatCertId: vatCertId});
  }

  async getExcelReport(year: any, month: any, timestamp: any) {
    let endpoint = '/rest/getExcelSalesReport?year=' + year + '&month=' + month + '&t=' + timestamp;
    // debugger;
    return this.getSecuredWithoutContentType(endpoint, 'text/csv');
  }

  async postLockSubAccount(subAccount: SubAccount) {
    let endpoint = '/rest/postLockSubAccount';
    return this.postSecured(endpoint, subAccount);
  }

  async postUnlockSubAccount(subAccount: SubAccount) {
    let endpoint = '/rest/postUnlockSubAccount';
    return this.postSecured(endpoint, subAccount);
  }

  async postMyInvoiceThemes(data: InvoiceThemes) {
    console.log('data', data);
    let endpoint = '/rest/postMyInvoiceThemes';
    return this.postSecured(endpoint, data);
  }

  async loadVatCertificates() {
    let endpoint = '/rest/getVatCertificates';
    return this.getSecured(endpoint);
  }

  async postTriggerAccountant(assignedSubAccount: SubAccount) {
    let endpoint = '/rest/subAccount/triggerAccountantAccountType';
    return this.postSecured(endpoint, assignedSubAccount);
  }

  async postTriggerSales(assignedSubAccount: SubAccount) {
    let endpoint = '/rest/subAccount/triggerSalesAccountType';
    return this.postSecured(endpoint, assignedSubAccount);
  }

  loadMerchantImage() {

  }

  async getProductsLabels(): Promise<string[]> {
    let endpoint = '/rest/getMyProductLabels';
    return this.getSecured(endpoint);
  }

  getAffiliateLink() {
    let endpoint = '/rest/getAffiliateLink';
    return this.getSecured(endpoint);
  }

  getAffiliateMerchantsCount() {
    let endpoint = '/rest/getAffiliateMerchantsCount';
    return this.getSecured(endpoint);
  }

  getAffiliateMerchants() {
    let endpoint = '/rest/getAffiliateMerchants';
    return this.getSecured(endpoint);
  }

  getAffiliateBalance() {
    let endpoint = '/rest/getAffiliateBalance';
    return this.getSecured(endpoint);
  }

  getAffiliateInvoices(page = 0, size = 20, sort = 'createdDate,desc') {
    const endpoint = `/rest/getAffiliateInvoices?page=${page}&size=${size}&sort=${sort}`;
    return this.getSecured(endpoint);
  }

  getWaiveSetupFees() {
    let endpoint = '/rest/getWaiveSetupFees';
    return this.getSecured(endpoint);
  }

  getTempMerchantsByStatus(status: string) {
    let endpoint = '/rest/partner/getTempMerchantsByStatus/' + status;
    return this.getSecured(endpoint);
  }

  async postCouponCode(productId: any, value: CouponCode): Promise<CouponCode[]> {
    let endpoint = '/rest/product/' + productId + '/coupons';
    return this.postSecured(endpoint, value);
  }

  async deleteCouponCode(productId: any, value: CouponCode): Promise<CouponCode[]> {
    let endpoint = '/rest/product/' + productId + '/coupons/delete';
    return this.postSecured(endpoint, value);
  }

  async createAffiliateWithdrawRequest(amount: number) {
    let endpoint = '/rest/createAffiliateWithdrawRequest';
    let data = {
      amount: amount
    };
    return this.postSecured(endpoint, data);
  }

  // Add this method to your ApiAgentService class
  async getAffiliateWithdrawRequests(page = 0, size = 10) {
    let endpoint = `/rest/getAffiliateWithdrawRequests?page=${page}&size=${size}`;
    return this.getSecured(endpoint);
  }
}
